import React from 'react'
import IconPng from 'atoms/IconPng'
import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import { withRouter } from 'react-router-dom'
import { FlexRow, FlexCol } from './styles'

const ic_err_404 = require('App/assets/images/ic_err_404.png')

const ErrorNotFound = ({ history: { goBack } }) => {
  return (
    <FlexRow>
      <FlexCol>
        <IconPng srcIcon={ic_err_404} size={'auto'} h={'220'} mb={'50px'} />
        <Label lineheight={'48px'} mb={'5px'} size={'36px'}>
          Page Not Found
        </Label>
        <Label weight={'400'} lineheight={'36px'} mb={'35px'} size={'18px'}>
          We're sorry, but something went wrong
        </Label>
        <ButtonReg
          btnTxt={'Back'}
          onClick={() => goBack()}
          btnType={'button'}
        />
      </FlexCol>
    </FlexRow>
  )
}

export default withRouter(ErrorNotFound)
